export default __webpack_public_path__ + "static/1308-9616525bb2cc25be03ee146af2b5ad41.gif";